module.exports = __webpack_public_path__ + "img/logo-W.bb63d046.png";